import React, { useCallback, useEffect, useRef, useState } from "react";
import { Row, Col, Input, Button, Icon, Typography } from "antd";
import axios from "axios";
import F from "../../../Functions";

const { Text, label } = Typography;

const AddressAutocomplete = ({ updateField, user, formError, type }) => {
  const [places, setPlaces] = useState([]);
  const [agencies, setAgencies] = useState([]);
  const address1Ref = useRef(null);

  const fetchAddress = async (val, search_type = "") => {
    if (val.length > 2) {
      try {
        const resp = await axios.get(
          `/api/google_maps/google_search_maps?query=${val}`
        );
        if (resp.data.success === true)
          if (search_type === "Agencies")
            setAgencies(resp.data.response_json.results);
          else setPlaces(resp.data.response_json.results);
      } catch (error) {
        console.error("Error fetching address:", error);
      }
    } else {
      setAgencies([]);
      setPlaces([]);
    }
  };

  // Debounced version of the fetchAddress function
  const debouncedFetchAddress = useCallback(F.debounce(fetchAddress, 300), []);

  const handlePlaceSearch = (e, search_type = "") => {
    const val = e.target.value.replace(/^\s+/, "");
    if (type === "Agency Address") {
      search_type === "Agencies"
        ? updateField("agency_name", val)
        : updateField("street_address", val);
    } else updateField("billing_street_address", val);
    debouncedFetchAddress(val, search_type);
  };

  const handleAutoFill = async (placeId, search_type = "") => {
    try {
      const resp = await axios.get(
        `/api/google_maps/google_fetch_place_by_place_id?place_id=${placeId}`
      );

      if (resp.data.success === true) {
        let address = {
          agency_name:
            search_type !== "agency"
              ? user.agency_name
              : resp.data.place_name || "NA",
          // "agency_address": resp.data.street1 + "," + resp.data.street2 + "," + resp.data.city + "," + resp.data.state + "," + resp.data.zip_code || "NA",
          agency_address:
            [
              resp.data.street,
              resp.data.city,
              resp.data.state,
              resp.data.zip_code,
              resp.data.country,
            ]
              .filter((value) => value)
              .join(", ") || "NA",
          street_address: resp.data.street|| "",
          // "street_address2": resp.data.street2 || "NA",
          city: resp.data.city || "NA",
          state: resp.data.state || "NA",
          zipcode: resp.data.zip_code || "NA",
        };
        if (type !== "Agency Address") {
          address = {
            billing_address:
              [
                resp.data.street,
                resp.data.city,
                resp.data.state,
                resp.data.zip_code,
                resp.data.country,
              ]
                .filter((value) => value)
                .join(", ") || "NA",
            billing_street_address:
              resp.data.street || "NA",
            // "billing_street_address2": resp.data.street2 || "",
            billing_city: resp.data.city || "NA",
            billing_state: resp.data.state || "NA",
            billing_zipcode: resp.data.zip_code || "NA",
          };
        }
        updateField("address", address);

        setPlaces([]);
        setAgencies([]);
      }
    } catch (error) {
      console.error("Error fetching address:", error);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      setAgencies([]);
      setPlaces([]);
    }
  };

  const handleClose = () => {
    setAgencies([]);
    setPlaces([]);
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const renderDropDown = (location = [], search_type = "") => {
    return (
      <div
        style={{
          position: "absolute",
          top: "80%",
          left: "3%",
          width: "95%",
          border: "1px solid #ccc",
          borderRadius: "4px",
          backgroundColor: "#fff",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          zIndex: 10,
        }}
      >
        <div
          style={{
            padding: "5px 10px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          Address Suggestion
          <Button onClick={handleClose}>
            <Icon type="close" />
          </Button>
        </div>
        <div
          style={{
            overflow: "auto",
            maxHeight: 500,
          }}
        >
          {location.map((suggestion, index) => (
            <div
              key={index}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  this.logout(); // NOSONAR
                }
              }}
              tabIndex="0"
              style={{
                padding: "10px",
                cursor: "pointer",
                borderBottom: "1px solid #eee",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => handleAutoFill(suggestion.place_id, search_type)}
            >
              <img
                src="https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png"
                alt="icon"
                style={{ width: "20px", marginRight: "10px" }}
              />
              <div>
                <strong>{suggestion.name}</strong>
                <p style={{ margin: 0, fontSize: "12px", color: "#555" }}>
                  {suggestion.formatted_address}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <Row>
      {type === "Agency Address" ? (
        <React.Fragment>
          <Row gutter={16}>
            <Col md={12} span={24}>
              <div className="inputField">
                <label>
                  Agency Name:
                  <span className="asteriskIcon">*</span>
                </label>
                <Input
                  value={user.agency_name}
                  className={
                    formError.agency_nameValid == false ? "invalid" : ""
                  }
                  // onChange={(e) => {
                  //     const val = (e.target.value.replace(/^\s+/, '')); //Remove space from the start
                  //     updateField("agency_name", val)
                  // }}
                  onChange={(e) => handlePlaceSearch(e, "Agencies")}
                  maxLength={255}
                />
              </div>
              {agencies.length > 0 && renderDropDown(agencies, "agency")}
            </Col>
          </Row>
          <Row gutter={16}>
            <Col md={12} span={24}>
              <div className="inputField">
                <label>
                  Street Address:
                </label>
                <Input
                  type="text"
                  id="ship-address"
                  ref={address1Ref}
                  value={user.street_address}
                  className={formError.street_address == false ? "invalid" : ""}
                  onChange={(e) => handlePlaceSearch(e)}
                  maxLength={100}
                />
              </div>
              {places.length > 0 && renderDropDown(places)}
            </Col>
            <Col md={12} span={24}>
              <div className="inputField">
                <label>Street Address 2:</label>
                <Input
                  type="text"
                  id="address2"
                  value={user.street_address2}
                  onChange={(e) => {
                    const val = e.target.value.replace(/^\s+/, ""); //Remove space from the start
                    updateField("street_address2", val);
                  }}
                  maxLength={100}
                />
              </div>
            </Col>
            <Col md={6} span={12}>
              <div className="inputField">
                <label>
                  City:
                </label>
                <Input
                  type="text"
                  id="locality"
                  value={user.city}
                  className={formError.city == false ? "invalid" : ""}
                  onChange={(e) => {
                    const val = e.target.value.replace(/^\s+/, "");
                    updateField("city", val);
                  }}
                  name="city"
                  maxLength={50}
                />
              </div>
            </Col>
            <Col md={6} span={12}>
              <div className="inputField">
                <label>
                  State:
                </label>
                <Input
                  type="text"
                  id="state"
                  value={user.state}
                  className={formError.state == false ? "invalid" : ""}
                  onChange={(e) => {
                    const val = e.target.value.replace(/^\s+/, "");
                    updateField("state", val);
                  }}
                  maxLength={50}
                />
              </div>
            </Col>
            <Col md={6} span={12}>
              <div className="inputField">
                <label>
                  Zipcode:
                </label>
                <Input
                  type="text"
                  id="postcode"
                  value={user.zipcode}
                  className={formError.zipcode == false ? "invalid" : ""}
                  onChange={(e) => {
                    const val = e.target.value.replace(/^\s+/, "");
                    updateField("zipcode", val);
                  }}
                  maxLength={15}
                />
              </div>
            </Col>
            <Col md={6} span={24}>
              <div className="inputField">
                <label>Country:</label>
                <Input disabled value={"United States"} />
              </div>
            </Col>
          </Row>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Row gutter={16}>
            <Col md={12} span={24}>
              <div className="inputField">
                <label>
                  Street Address:
                </label>
                <Input
                  type="text"
                  id="ship-address"
                  ref={address1Ref}
                  value={user.billing_street_address}
                  className={
                    formError.billing_street_address == false ? "invalid" : ""
                  }
                  onChange={(e) => handlePlaceSearch(e)}
                  maxLength={100}
                />
              </div>
              {places.length > 0 && renderDropDown(places)}
            </Col>
            <Col md={12} span={24}>
              <div className="inputField">
                <label>Street Address 2:</label>
                <Input
                  type="text"
                  id="address2"
                  value={user.billing_street_address2}
                  onChange={(e) => {
                    const val = e.target.value.replace(/^\s+/, ""); //Remove space from the start
                    updateField("billing_street_address2", val);
                  }}
                  maxLength={100}
                />
              </div>
            </Col>
            <Col md={6} span={12}>
              <div className="inputField">
                <label>
                  City:
                </label>
                <Input
                  type="text"
                  id="locality"
                  value={user.billing_city}
                  className={formError.billing_city == false ? "invalid" : ""}
                  onChange={(e) => {
                    const val = e.target.value.replace(/^\s+/, "");
                    updateField("billing_city", val);
                  }}
                  name="city"
                  maxLength={50}
                />
              </div>
            </Col>
            <Col md={6} span={12}>
              <div className="inputField">
                <label>
                  State:
                </label>
                <Input
                  type="text"
                  id="state"
                  value={user.billing_state}
                  className={formError.billing_state == false ? "invalid" : ""}
                  onChange={(e) => {
                    const val = e.target.value.replace(/^\s+/, "");
                    updateField("billing_state", val);
                  }}
                  maxLength={50}
                />
              </div>
            </Col>
            <Col md={6} span={12}>
              <div className="inputField">
                <label>
                  Zipcode:
                </label>
                <Input
                  type="text"
                  id="postcode"
                  value={user.billing_zipcode}
                  className={
                    formError.billing_zipcode == false ? "invalid" : ""
                  }
                  onChange={(e) => {
                    const val = e.target.value.replace(/^\s+/, "");
                    updateField("billing_zipcode", val);
                  }}
                  maxLength={15}
                />
              </div>
            </Col>
            <Col md={6} span={24}>
              <div className="inputField">
                <label>Country:</label>
                <Input disabled value={"United States"} />
              </div>
            </Col>
          </Row>
        </React.Fragment>
      )}
    </Row>
  );
};

export default AddressAutocomplete;



// WEBPACK FOOTER //
// ./src/scenes/Register/parts/address.js